module.exports = __webpack_public_path__ + "12097dbd339258ef11bc23b1568c6d6f.svg";